import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

interface PasswordChangeRouteProps {
  children: ReactNode;
}

function PasswordChangeRoute({ children }: PasswordChangeRouteProps) {
  const auth = useAuth();

  if (!auth || !auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default PasswordChangeRoute;
